import { render, staticRenderFns } from "./DadosRevenda.vue?vue&type=template&id=7fda040b&scoped=true"
import script from "./DadosRevenda.vue?vue&type=script&lang=js"
export * from "./DadosRevenda.vue?vue&type=script&lang=js"
import style0 from "./DadosRevenda.vue?vue&type=style&index=0&id=7fda040b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fda040b",
  null
  
)

export default component.exports